import React from 'react';
import { BsTwitter, BsInstagram, BsYoutube, BsGithub } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => (
  <div className="app__social">
    {/* <div>
      <BsTwitter />
    </div> */}
    {/* <div>
      <a
        href="https://www.youtube.com/channel/UCwlyIVnAqJd7W_36CPiVuOQ/videos"
        target="_blank"
      >
        <BsYoutube />
      </a>
    </div> */}
    <div>
      <a
        href="https://github.com/ahjam-taoufik"
        target="_blank"
      >
        <BsGithub />
      </a>
    </div>
    {/* <div>
      <FaFacebookF />
    </div> */}
    {/* <div>
      <BsInstagram />
    </div> */}
  </div>
);

export default SocialMedia;
